<template>
  <v-dialog max-width="600px" v-model="dialog" @keydown.enter.prevent="onenter">
    <v-card>
      <v-card-title>
        <span class="headline">Bundle Firefly ({{ this.rules.name }})</span>
      </v-card-title>
      <v-card-text>
        <v-row dense class="mb-4">
          <v-col cols="12" md="12" sm="12">
            <v-text-field disabled label="UID:" v-model.trim="model.uid" hide-details outlined dense/>
          </v-col>
          <v-col cols="12" md="4" sm="4">
            <r-firefly-kind :model.sync="model.firefly" label="Type"/>
          </v-col>
          <v-col cols="12" md="4" sm="4">
            <v-text-field
              label="Name"
              v-model.trim="model.name"
              v-ascii-only
            />
          </v-col>
          <v-col cols="12" md="4" sm="4">
            <v-text-field
              label="Key"
              v-model.trim="model.key"
              v-ascii-only
            />
          </v-col>
        </v-row>
        <v-expansion-panels>
          <r-guard-panel :model.sync="model.guard" title="Guard Config"/>
          <r-guard-money-panel :model.sync="model.guardMoney" title="Guard Money"/>
        </v-expansion-panels>
        <v-row dense class="mt-3">
          <v-col cols="12" md="2" sm="2">
            <v-text-field label="Delay time" v-model.number="model.delayTime" hide-details/>
          </v-col>
          <v-col cols="12" md="2" sm="2">
            <v-text-field label="Cooldown" v-model.number="model.cooldown" hide-details/>
          </v-col>
          <v-col cols="12" md="2" sm="2">
            <v-text-field label="Reset time:" v-model.number="model.resetTime" hide-details/>
          </v-col>
          <v-col cols="12" md="2" sm="2">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-text-field label="Max limit:" v-bind="attrs" v-on="on" v-model="model.quantity"
                              hide-details/>
              </template>
              <span>[2*D(6)+S]</span>
            </v-tooltip>
          </v-col>
        </v-row>
        <v-row dense class="mb-4">
          <v-col cols="12" md="6" sm="6">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-text-field label="Count" v-bind="attrs" v-on="on" v-model="model.density"
                              hide-details/>
              </template>
              <span>[2*D(6)+S]</span>
            </v-tooltip>
          </v-col>
          <v-col cols="12" md="6" sm="6">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-text-field label="Interval" v-bind="attrs" v-on="on" v-model="model.interval"
                              hide-details/>
              </template>
              <span>[2*D(6)+S]</span>
            </v-tooltip>
          </v-col>
        </v-row>
        <v-expansion-panels>
          <r-reward-panel :model.sync="model.reward" title="Rewards"/>
        </v-expansion-panels>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn @click="cancel" color="blue darken-1" text>
          Cancel
        </v-btn>
        <v-btn @click="save" color="blue darken-1" text>
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

import {ViewRules} from "@/common/ViewRules";
import {SmartOfferBundleFirefly} from "@/modules/redactor/models/smart-offer/bundle-firefly/SmartOfferBundleFirefly";
import RGuardPanel from "@/modules/redactor/views/guard/r-guard-panel.vue";
import RGuardMoneyPanel from "@/modules/redactor/views/guard/r-guard-money-panel.vue";
import RFireflyKind from "@/modules/redactor/views/firefly/r-firefly-kind.vue";
import RRewardPanel from "@/modules/redactor/views/reward/r-reward-panel.vue";

export default
{
  name: "r-smart-offer-bundle-firefly",
  components: {RRewardPanel, RFireflyKind, RGuardMoneyPanel, RGuardPanel},
  data: () => ({
    dialog: false,
    resolve: null,
    reject: null,
    tab: null,
    model: new SmartOfferBundleFirefly(),
    rules: ViewRules.READONLY,
  }),
  methods: {
    show(rules, model) {
      this.dialog = true;
      this.tab = null;
      this.rules = rules;
      this.model = model || new SmartOfferBundleFirefly();

      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    save() {
      if (this.model.valid()) {
        this.resolve(this.model);
        this.discard();
      } else {
        this.$alert("Invalid config!");
      }
    },
    cancel() {
      this.reject();
      this.discard();
    },
    discard() {
      this.dialog = false;
    },
    onenter() {
      this.save();
    }
  }
}
</script>